import { render, staticRenderFns } from "./calendarForm.vue?vue&type=template&id=2c624c4c&scoped=true&"
import script from "./calendarForm.vue?vue&type=script&lang=js&"
export * from "./calendarForm.vue?vue&type=script&lang=js&"
import style0 from "./calendarForm.vue?vue&type=style&index=0&id=2c624c4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c624c4c",
  null
  
)

export default component.exports